/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const Folder2StrokeIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M12.5 6.5L11.4373 5.43726C11.0914 5.09135 10.9184 4.9184 10.7166 4.79472C10.5376 4.68506 10.3425 4.60425 10.1385 4.55526C9.90829 4.5 9.6637 4.5 9.17452 4.5H6.2C5.0799 4.5 4.51984 4.5 4.09202 4.71799C3.71569 4.90973 3.40973 5.21569 3.21799 5.59202C3 6.01984 3 6.5799 3 7.7V8.5M12.5 6.5H17.8C18.9201 6.5 19.4802 6.5 19.908 6.71799C20.2843 6.90973 20.5903 7.21569 20.782 7.59202C21 8.01984 21 8.57989 21 9.7V16.3C21 17.4201 21 17.9802 20.782 18.408C20.5903 18.7843 20.2843 19.0903 19.908 19.282C19.4802 19.5 18.9201 19.5 17.8 19.5H6.2C5.07989 19.5 4.51984 19.5 4.09202 19.282C3.71569 19.0903 3.40973 18.7843 3.21799 18.408C3 17.9802 3 17.4201 3 16.3V8.5M12.5 6.5L11.4373 7.56274C11.0914 7.90865 10.9184 8.0816 10.7166 8.20528C10.5376 8.31494 10.3425 8.39575 10.1385 8.44474C9.90829 8.5 9.6637 8.5 9.17452 8.5H3"
          strokeLinecap="round"
        />
      </svg>
    </Icon>
  );
});

export { Folder2StrokeIcon };
